export function getPatchNumberByAddress(bytes) {
    if (bytes.length !== 3) {
        return "Invalid byte length";
    }

    const baseAddress = bytes[0];
    const subBlock = bytes[1];
    const patchLetter = baseAddress >= 4 ? "B" : "A";
    const patchNumber = (baseAddress % 4) * 32 + Math.floor(subBlock / 4) + 1;

    return "U" + patchLetter + patchNumber;
}

export function getPatchNumberByAddressString(address) {
    return getPatchNumberByAddress(getAddressBytesByString(address));
}

export function getAddressBytesByString(address) {
    return address.split(",").map((byte) => parseInt(byte, 10));
}

export function getAddressByPatchNumber(patchNumber) {
    const patchLetter = patchNumber.substring(1, 2);
    const patchNumberString = patchNumber.substring(2);
    const baseAddress = (patchLetter === "A" ? 0 : 4) + Math.floor((patchNumberString - 1) / 32);
    const subBlock = (patchNumberString - 1) % 32 * 4
    const offset = 0;

    return [baseAddress, subBlock, offset];
}

export function calcOffset(bytes1, bytes2) {
    const baseAddress1 = bytes1[0];
    const subBlock1 = bytes1[1];
    const offset1 = bytes1[2];
    const baseAddress2 = bytes2[0];
    const subBlock2 = bytes2[1];
    const offset2 = bytes2[2];
    return [baseAddress2 - baseAddress1, subBlock2 - subBlock1, offset2 - offset1];
}

export function calcAddressByOffset(bytes, offset) {
    const baseAddress1 = bytes[0];
    const subBlock1 = bytes[1];
    const offset1 = bytes[2];
    const baseAddressOffset = offset[0];
    const subBlockOffset = offset[1];
    const offsetOffset = offset[2];
    return [baseAddress1 + baseAddressOffset, subBlock1 + subBlockOffset, offset1 + offsetOffset];
}

export function calcChecksum(data) {
    return 0x80 - data.reduce((sum, current) => sum + current, 0) & 0x7F;
}

export function globalChangeMessage(midiOut, deviceId, value, address) {
    if (midiOut) {
        const content = [0x00, 0x00, Math.floor(value / 16) , value % 16];
        const dataSetMessage = [0xF0, 0x41, deviceId, 0x00, 0x23, 0x12, ...address, ...content, calcChecksum([...address, ...content]), 0xF7];
        midiOut.send(dataSetMessage);
    }
}

export const outLevelAddress = [0x08, 0x01, 0x1C];
export const noiseThresholdAddress = [0x08, 0x01, 0x20];
export const reverbLevelAddress = [0x08, 0x01, 0x24];

export const MidiAccessStatus = {
    initializing: 0,
    success: 1,
    denied: 2,
    unsupported: 3,
}